import { createAction } from "@reduxjs/toolkit";
import {
  FinancialCategoryEnumModel,
  IAggregateDataSummaryModel,
  ICategoryDataSummaryModel,
  IBusinessPlanningDataModel,
  IBusinessZonesResponse,
} from "../../../types/types";
import { IFinancialCategoryDataSummaryModel } from "../../../types/models";

export const getCategoryDataSummaryPending = createAction<string>(
  "analytics/getCategoryDataSummaryPending",
);
export const getCategoryDataSummaryFulfilled = createAction<{
  categoryId: string;
  data: ICategoryDataSummaryModel[];
}>("analytics/getCategoryDataSummaryFulfilled");
export const getCategoryDataSummaryRejected = createAction<{
  categoryId: string;
  error: string;
}>("analytics/getCategoryDataSummaryRejected");

//
export const getFinCategoryDataSummaryPending =
  createAction<FinancialCategoryEnumModel>(
    "analytics/getFinCategoryDataSummaryPending",
  );
export const getFinCategoryDataSummaryFulfilled = createAction<{
  categoryId: FinancialCategoryEnumModel;
  data: IFinancialCategoryDataSummaryModel[];
}>("analytics/getFinCategoryDataSummaryFulfilled");
export const getFinCategoryDataSummaryRejected = createAction<{
  categoryId: FinancialCategoryEnumModel;
  error: string;
}>("analytics/getFinCategoryDataSummaryRejected");
//
export const getAggregateDataSummaryPending = createAction<string>(
  "analytics/getAggregateDataSummaryPending",
);

export const getAggregateDataSummaryFulfilled = createAction<{
  categoryId: string;
  data: IAggregateDataSummaryModel[];
}>("analytics/getAggregateDataSummaryFulfilled");

export const getAggregateDataSummaryRejected = createAction<{
  categoryId: string;
  error: string;
}>("analytics/getAggregateDataSummaryRejected");

// Business Planning Actions
export const getBusinessPlanningDataPending = createAction(
  "analytics/getBusinessPlanningDataPending",
);
export const getBusinessPlanningDataFulfilled =
  createAction<IBusinessPlanningDataModel>(
    "analytics/getBusinessPlanningDataFulfilled",
  );
export const getBusinessPlanningDataRejected = createAction<string>(
  "analytics/getBusinessPlanningDataRejected",
);
export const clearBusinessPlanningData = createAction(
  "analytics/clearBusinessPlanningData",
);

// Business Zones Actions
export const getBusinessZonesDataPending = createAction(
  "analytics/getBusinessZonesDataPending",
);
export const getBusinessZonesDataFulfilled =
  createAction<IBusinessZonesResponse>(
    "analytics/getBusinessZonesDataFulfilled",
  );
export const getBusinessZonesDataRejected = createAction<string>(
  "analytics/getBusinessZonesDataRejected",
);
export const clearBusinessZonesData = createAction(
  "analytics/clearBusinessZonesData",
);
